{
  "mod": "images/badges/modbadge.png",
  "speaker": "images/badges/speakerbadge.png"
}